import React, { useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import * as s from './styled-sistemas';

const Sistemas = () => {
  const [selected, setSelected] = useState('energia');
  const { colors } = useContext(ThemeContext);

  const tags = [
    {
      label: 'erro',
      value: 6,
      color: colors.red,
    },
    {
      label: 'alarme',
      value: 7,
      color: colors.orange,
    },
    {
      label: 'alarmado',
      value: 5,
      color: colors.yellow,
    },
    {
      label: 'funcionando',
      value: 22,
      color: colors.lightgreen,
    },
    {
      label: 'desligada',
      value: 5,
      color: colors.label,
    },
  ];

  return (
    <s.Container>
      <s.Label size="16px" color={colors.darkerblue}>
        Sistemas
      </s.Label>
      <s.ButtonContainer>
        <s.Button
          title="Gerçao de Energia"
          onClick={() => setSelected('energia')}
          selected={selected === 'energia'}
        >
          Gerçao de Energia
        </s.Button>
        <s.Button
          title="Bombeamento"
          onClick={() => setSelected('bombeamento')}
          selected={selected === 'bombeamento'}
        >
          Bombeamento
        </s.Button>
      </s.ButtonContainer>
      <s.Label size="12px" color={colors.darkblue}>
        43 equipamentos notificados
      </s.Label>
      <s.TagsContainer>
        {tags.map((tag) => (
          <s.Tag key={tag.label} background={tag.color}>
            <label>{tag.label}</label>
            <div>{tag.value} equip.</div>
          </s.Tag>
        ))}
      </s.TagsContainer>
      <s.FooterContainer>
        <s.Label margin="0 10px 0 0" size="14px" color={colors.darkblue}>
          Total em operação
        </s.Label>
        <s.Label size="22px" color={colors.darkblue}>
          38 equip.
        </s.Label>
      </s.FooterContainer>
    </s.Container>
  );
};

export default Sistemas;
